const getLogoProps = (options = {}) => {
  const {theme, themeId} = options;

  if (theme && theme.logoSrc) {
    return {
      src: theme.logoSrc
    };
  }

  if (themeId) {
    return {
      src: new URL(`/${themeId}/img/logo.next.svg`, window.env.THEMES_URL).href
    };
  }

  return {};
};

export default getLogoProps;
